import React, { useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import en from 'react-phone-number-input/locale/en';
import es from 'react-phone-number-input/locale/es';
import i18n from 'i18next';
import PhoneInput from 'react-phone-number-input';
import images from '~/constants/images';
import * as S from './styles';
import { ErrorMessage } from '~/components/Form/styles';
import Icon from '~/components/Icon';

export default function Input({
  selector,
  label,
  type,
  formikProps,
  placeholder,
  disabled,
  icon,
  flashyEntrance,
  setRef,
  forceErrorBorder,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    setRef(inputRef);
  }, [selector, setRef]);

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    submitCount,
  } = formikProps;
  const hasError = (touched[selector] || submitCount > 0) && !!errors[selector];
  return (
    <S.Container type={type} disabled={disabled}>
      {label && (
        <S.Label shouldShow={values[selector] !== ''} htmlFor={selector}>
          {label}
        </S.Label>
      )}
      <S.InputWrapper
        errorColor={(errors[selector] && touched[selector]) || forceErrorBorder}
        flashyEntrance={flashyEntrance}
        type={type}
      >
        {icon && <Icon size={22} name={icon} color="gray2" />}
        {type === 'tel' ? (
          <S.InputTel>
            <PhoneInput
              flagUrl={`${images.flags}/4x3/{xx}.svg`}
              labels={i18n.language === 'es' ? es : en}
              defaultCountry="ES"
              id={selector}
              type={type}
              placeholder={placeholder}
              value={values[selector]}
              onBlur={handleBlur}
              disabled={disabled}
              onChange={valueInput => {
                setFieldValue(selector, valueInput);
              }}
            />
          </S.InputTel>
        ) : (
          <S.Input
            ref={inputRef}
            id={selector}
            type={type}
            value={values[selector]}
            onChange={value => {
              handleChange(value);
            }}
            onBlur={handleBlur}
            placeholder={placeholder}
            disabled={disabled}
            checkboxError={
              type === 'checkbox' && errors[selector] && touched[selector]
            }
          />
        )}
      </S.InputWrapper>
      <ErrorMessage shouldShow={hasError}>
        {hasError ? errors[selector] : null}
      </ErrorMessage>
    </S.Container>
  );
}

Input.propTypes = {
  selector: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  formikProps: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  flashyEntrance: PropTypes.bool,
  setRef: PropTypes.func,
  forceErrorBorder: PropTypes.bool,
};

Input.defaultProps = {
  label: '',
  placeholder: '',
  disabled: false,
  icon: null,
  flashyEntrance: false,
  setRef: () => {},
  forceErrorBorder: false,
};
